import React, { Suspense, Fragment } from "react";
import { Route } from "react-router-dom";
import Loading from "../../components/common/Loading";
import "./Home.css";

const Home = (props) => {
  return (
    <div className="homeWrapper">
      <div className="homeContainer">
        {props.isAuthenticated === undefined ? (
          <Loading />
        ) : (
          <Fragment>
            <div className="homeCol2 bannerLeft leftBg">
              <div className="bannerCtnr">
                <div className="bannerHdngBlock">
                  <h1 className="headingLine margBtm">
                    {props.language.build}{" "}
                    <span>{props.language.virtual_com}</span>
                    {props.language.home_instavc_build}
                  </h1>
                </div>
                <div className="bannerPort margBtm">
                  {/* <img src="./images/banners/banner-new-second.jpg" alt="" /> */}
                </div>
                <div className="flexCol bannerHdngBlock">
                  <div className="inlineBlock">
                    <span>
                      {props.language.home_instavc_conference_platform}
                    </span>
                  </div>
                  <div className="inlineBlock">
                    <span className="oranclr">
                      {props.language.home_instavc_start_conference}
                    </span>
                  </div>
                  <div className="inlineBlock">
                    <span>{props.language.home_instavc_Hippa}</span>
                  </div>
                </div>
              </div>
              {/* <div className="bannerFixedBlock">
                
              </div> */}
            </div>
            <div className="homeCol2 brdrWLeft overflowFlexBox">
              <Suspense fallback={<Loading />}>
                <Route
                  exact
                  path={props.path}
                  {...props}
                  component={props.component}
                />
              </Suspense>
              {/* <div className="copyright">
                {props.language.home_inclass_copyright}
              </div> */}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default Home;